import React from "react";
import { Accordion } from "react-bootstrap";
import { accordionImg } from "../../../assets/images";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import { decryptData } from "../../../utils/helper";

const FAQ = ({ type }) => {
  const { getFaqApi } = PublicService();

  const { data, isPending, error } = useQuery({
    queryKey: ["faqs"],
    queryFn: () => getFaqApi({ type }),
  });
  const faqs = data?.data?.faqs || [];

  return (
    <>
      <div className="faq spacing" id="faq">
        <div className="container">
          <div className="page_title">
            <h2>Frequently Asked Questions</h2>
            <p>
             Explore the most common questions about our women’s Healthcare and homeopathy solutions. Gain access to quick and helpful information to make informed health choices.
            </p>
          </div>
          <div className="faq_content">
            <div className="image_wrap">
              <img src={accordionImg} alt="accordian-image" />
            </div>
            <div className="content">
              <Accordion defaultActiveKey="0">
                {faqs?.map((data, i) => (
                  <Accordion.Item eventKey={String(i)}>
                    <Accordion.Header as={"h3"}>{data?.title || ""}</Accordion.Header>
                    <Accordion.Body>{data?.description || ""}</Accordion.Body>
                  </Accordion.Item>
                ))}
                {/* <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    How do I create an account on the website?
                  </Accordion.Header>
                  <Accordion.Body>
                    To create an account, click on the "Sign Up" button on the
                    homepage. Enter your email, phone number, and password, then
                    follow the verification steps. Once verified, you can start
                    exploring the platform
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header> I forgot my password. How can I reset it?</Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>How can I contact support if I face login or sign-up issues?</Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Is my personal information secure when I sign up?</Accordion.Header>
                  <Accordion.Body>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Accordion.Body>
                </Accordion.Item> */}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
